import { Component, Input, OnInit } from "@angular/core";
import { LienTache } from "../../../../models/taches/gestion-taches.model";
import { PersonnesService } from "../../../../services/personnes/personnes.service";
import { PersonneModel } from "../../../../models/personnes/personne.model";
import { base64string } from "../../../../utils/file-conversions-util";
import { Subscription } from "rxjs";

@Component({
  selector: 'app-lien-personne-details-tooltip',
  templateUrl: './lien-personne-details-tooltip.component.html',
  styleUrls: ['./lien-personne-details-tooltip.component.scss']
})
export class LienPersonneDetailsTooltipComponent implements OnInit {
  @Input() set lien(value: LienTache) {
    this.idPersonne = value.idOriginal;
    if (value) {
      this.loadPersonneDetails()
      this.loadPhoto()
    }
  }
  public personne: PersonneModel;
  public photoData: base64string;
  public hideCancelled = false
  private idPersonne: number = null;
  public sub: Subscription[] = [];
  
  constructor(private personneService: PersonnesService) { }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.map(ob => ob.unsubscribe());
  }

  hasEmail() : boolean {
    return this.personne.email != null && this.personne.email.length>0
  }

  get hasTelephone(): boolean {
    return (this.personne.telephone != null && this.personne.telephone.length>0)
  }

  private loadPersonneDetails() {
    this.sub.push(
      this.personneService.getPersonneDetaillee(this.idPersonne).subscribe(personne => this.personne = personne)
    );
  }

  private loadPhoto() {
    this.sub.push(
      this.personneService.chargerPhotoAsBase64(this.idPersonne).subscribe(photoData => this.photoData = photoData)
    );
  }
}
